import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Snackbar from '../../brastrap/components/global/snackbar/Snackbar';

const SnackBar = ({ message, triggerSnackbar, type }) => {
  return (
    <Snackbar message={message} triggerSnackbar={triggerSnackbar} type={type} />
  );
};

const mapStateToProps = ({ snackbar }) => ({
  ...snackbar,
});

SnackBar.propTypes = {
  message: PropTypes.string,
  triggerSnackbar: PropTypes.number,
  type: PropTypes.string,
};

export default connect(mapStateToProps)(SnackBar);
